module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-calabria-costa-tirrenica.svg?f465ddc40ea88914ac3d60a8a1ca60cb";